import { CurrentDataSourceStatusResponse, ItemsResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function getDatasourcesStatuses() {
	const fetchData = async () => {
		const data = await apiClientMutator<ItemsResponse<CurrentDataSourceStatusResponse[]>>({
			url: '/datasources-statuses',
			method: 'get',
		});
		return data;
	};
	return fetchData();
}
